import {
  pick as _pick,
  omit as _omit,
  isNil,
  isPlainObject,
  isEmpty as isEmptyObj,
  isNull
} from 'lodash'

import { GenericalRecord, StrictOmit } from '../types/utilities'

/**
 * 从对象中获取指定集合的值，返回新的对象
 *
 * @param data 数据源
 * @param keys 键集合
 */
export const pick: <T extends GenericalRecord, K extends keyof T>(
  data: T,
  keys: K[]
) => Pick<T, K> = _pick

/**
 * 从对象中排除指定集合的值，返回新的对象
 *
 * @see _omit lodash.omit
 *
 * @param data 数据源
 * @param keys 键集合
 */
export const omit: <T extends GenericalRecord, K extends keyof T>(
  data: T,
  keys: K[]
) => StrictOmit<T, K> = _omit

/**
 * 获取对象的键集合，包装自 Object.keys 解决返回值类型问题
 *
 * @param data 对象
 * @returns 对象的键集合
 */
export const keys: <T extends GenericalRecord, K extends keyof T>(
  data: T
) => K[] = Object.keys

/**
 * 判断是否是空数据
 *
 * @param data 数据
 * @param key key
 * @returns boolean
 */
export const isEmpty = <T>(data: T): data is T & (null | undefined) => {
  if (isNil(data)) {
    return true
  }

  if (Array.isArray(data) || typeof data === 'string') {
    return !data.length
  }

  if (isPlainObject(data)) {
    return (
      isEmptyObj(data as Record<string, any>) ||
      Object.values(data as Record<string, any>).every(value => isNull(value))
    )
  }

  return false
}
